import { RecommendJobAlertPageView } from './RecommendJobAlertPage'
export default RecommendJobAlertPageView
